// extracted by mini-css-extract-plugin
export default {"popover":"Popover_popover__8JgVr","box":"Popover_box__+quq2","arrow":"Popover_arrow__3gUm4"};